import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { BUTTON__CONTENT_CLASS } from '../constants';
import { baseButton } from '../styles/base.styles';
const { fonts, responsiveText } = theme;

const SMALL_SIZE = 36;
const SMALL_HOVER_SIZE = SMALL_SIZE - 4;
const LARGE_SIZE = 44;
const LARGE_HOVER_SIZE = LARGE_SIZE - 4;

export const small = css`
  width: ${SMALL_SIZE}px;
  height: ${SMALL_SIZE}px;

  &:active {
    transform: scale(${SMALL_HOVER_SIZE / SMALL_SIZE});
  }
`;

export const large = css`
  width: ${LARGE_SIZE}px;
  height: ${LARGE_SIZE}px;

  &:active {
    transform: scale(${LARGE_HOVER_SIZE / LARGE_SIZE});
  }
`;

export const iconButton = css`
  ${baseButton}
  border-radius: 50%;
  background: var(--neutral-white-base);
  border: none !important;

  .${BUTTON__CONTENT_CLASS} {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    height: ${pxToRem(28)};
    ${responsiveText.BODY.MD}
    display: flex;
    justify-content: center;
  }

  &:hover {
    background-color: var(--neutral-black-10);
  }

  &:active,
  &[data-is-active='true'] {
    background-color: var(--brand-purple-30);
  }
`;

export const brandStyles = css`
  color: var(--brand-purple-base);

  &:hover {
    background-color: var(--brand-purple-30);
  }
`;

export const borderStyles = css`
  border: solid ${pxToRem(1)} !important;
`;
